import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { TabView } from 'primereact/tabview';

export const MultipageContext = React.createContext(null);

function Multipage({ children, initialData = null, onBeforeChange, ...rest }, ref) {
    const [tab, setTab] = useState({ active: 0, last: null });
    const [multipageData, setMultipageData] = useState(initialData);

    const alterTab = (aba) => {
        setTab({ active: aba, last: tab });
    };

    useImperativeHandle(
        ref,
        () => {
            return {
                activeTab: tab?.active,
                alterTab,
                multipageData,
                addDataToContext: (novo) => {
                    setMultipageData({ ...multipageData, ...novo });
                },
            };
        },
        [tab, multipageData]
    );

    return (
        <MultipageContext.Provider
            value={{
                ...multipageData,
                setMultipageData,
            }}
        >
            <TabView
                activeIndex={tab?.active}
                onTabChange={(e) => {
                    if (onBeforeChange) {
                        onBeforeChange(e.index);
                    }
                    setTab({ active: e.index, last: tab?.active });
                }}
                {...rest}
            >
                {children}
            </TabView>
        </MultipageContext.Provider>
    );
}

export default forwardRef(Multipage);
